<template>
  <!-- <div v-if="wzlist && wzlist.length > 0" class="p-[10px] bobb rounded-[5px] bg-[#fff]">
    <div class="grid grid-cols-5 gap-2 box-border text-[12px] w-full">
      <div
        v-for="(item, index) in wzlist"
        :key="index"
        class="h-[25px] w-full text-[#fff] rounded-[3px] flex items-center justify-center text-center bor ovf-h"
        @click="handelUrl(item)"
      >
        {{ item.title }}
      </div>
    </div>
  </div> -->
  <div v-if="applist && applist.length > 0" class="p-[10px] pt-0 mt-[10px] rounded-[5px]">
    <div
      class="w-full md:flex md:items-center md:justify-between md:flex-wrap grid grid-cols-5 gap-2 box-border pt-[10px]"
    >
      <div
        v-for="(item, index) in applist"
        :key="index"
        class="w-full md:w-[120px] flex items-center flex-col text-[#fff]"
        :class="[applist.length <= 4 ? '' : 'mb-[2px]']"
        @click="handelUrl(item)"
      >
        <!--   v-lazy="{
            src: a,
            loading: b
          }" -->
        <img class="w-full mb-[5px] rounded-[10px]" v-lazy="item.logo" alt="" />
        <div class="w-full text-center text-[12px] md:text-[14px] text-center">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  wzlist: {
    type: Array,
    default: () => []
  },
  applist: {
    type: Array,
    default: () => []
  }
})
const handelUrl = (item) => {
  window.open(item.href, '_blank')
}
</script>

<style scoped>
.bor {
  line-height: 25px;

  background: #fcf8e3;
  border: 1px #faebcc solid;
  text-align: center;
  font-size: 12px;
  color: #8a6d3b;
  font-weight: 700;
  display: block;
}
.bobb {
  border: 1px solid #eee;
}
</style>
